export default __webpack_public_path__ + "static/media/ico_lock.de6554e5.svg";